import { CustodyAccountVerifiedEligibility } from "@modules/+new/custody_account/domain/entities/custody_account_eligibility.model";
import { CustodyAccountOpeningStep } from "@modules/+new/custody_account/features/cam-modal/cam-modal.model";

export interface CustodyAccountState {
	isEligible: boolean;
	isEligibilityLoaded: boolean;
	isVerificationLoading: boolean;
	verifiedEligibility: CustodyAccountVerifiedEligibility;
	currentStep: CustodyAccountOpeningStep;
}

export const CUSTODY_ACCOUNT_OPENING_MODAL = "custody-account";
